function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#18efa4;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0.723 0.749)"
}, React.createElement("path", {
  className: "a",
  d: "M-378.278,391.634h-22.811l-.047-.082-11.358-19.673,11.406-19.755h22.811l.047.082,11.358,19.673Zm-22.622-.328h22.433l11.216-19.427-11.216-19.427H-400.9l-11.216,19.427Z",
  transform: "translate(412.495 -352.124)"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(11.402)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(34.024)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(11.402 39.183)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(34.024 39.183)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826
}));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 19.591)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826
}));

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(45.244 19.591)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826,
  transform: "translate(0)"
}));

var _ref10 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(22.622 19.591)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826
}));

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(12.173 0.83)"
}, React.createElement("path", {
  className: "a",
  d: "M-331.289,372.623l-11.361-19.838.284-.163,11.079,19.345,11.259-19.346.283.165Z",
  transform: "translate(342.65 -352.621)"
}));

var _ref12 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(12.173 20.176)"
}, React.createElement("path", {
  className: "a",
  d: "M-320.028,490.642-331.287,471.3l-11.079,19.345-.284-.163,11.361-19.838,11.545,19.837Z",
  transform: "translate(342.65 -470.64)"
}));

var _ref13 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0.913 20.34)"
}, React.createElement("rect", {
  className: "a",
  width: 45.244,
  height: 0.328
}));

var SvgMarketingManager = function SvgMarketingManager(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 47.07,
    height: 41.008,
    viewBox: "0 0 47.07 41.008",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMarketingManager, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Marketing_Manager.fe3040b4.svg";
export { ForwardRef as ReactComponent };